import { createContext, useContext, useEffect, useState } from "react";

interface User{
    nom: string;
    roles: string[];
}

interface AuthContextType {
    user: User | null;
    login:(user:User) => void;
    logout: () => void;
    isLoading:boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] =useState<User | null>(null);
    const[isLoading,setIsLoading]=useState(true);

    const login = (user: User) => {
        setUser(user);
        localStorage.setItem("user",JSON.stringify(user))
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
    };

      useEffect(() => {
        const storedUser = localStorage.getItem("user");

        
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                if (parsedUser.nom && parsedUser.roles) {
                    setUser(parsedUser);
                }
            } catch (err) {
                console.error("Erreur parsing user depuis localStorage");
                setUser(null);
            }
        }
        setIsLoading(false);
    }, []);


    return (
        <AuthContext.Provider value={{ user, login, logout, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = ():AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
